import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { AdminManagedBadge } from 'components/core/admin_managed_badge'

import { SubtitleContent } from './styles'

export const Footer = ({ isMETChild, kindDescription, groupManaged }) => {
  const translatedString = groupManaged
    ? I18n.t('publisher.organization.managed_event_types.group_managed_badge')
    : I18n.t('publisher.organization.managed_event_types.admin_managed_badge')

  return (
    <div>
      <SubtitleContent>
        <BodyText color="muted" size="medium">{kindDescription}</BodyText>
        {isMETChild && <AdminManagedBadge text={translatedString} />}
      </SubtitleContent>
    </div>
  )
}
